import { css } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import { Theme, useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Modal from "react-modal";
import { match } from "ts-pattern";

import DatabaseContent from "~/components/database/detail/database-content";
import ItemModalContent from "~/components/database/detail/item-modal-content";
import { ModalContentKind } from "~/components/database/detail/lib";
import ResponseModalContent from "~/components/database/detail/response-modal-content";
import { Props } from "~/components/database/page/[id]/database-detail-page";
import { flexRow } from "~/lib/client/design";

const PcPage = ({
  props,
  openResponseForm,
  openItemDetail,
  modalContent,
  setSuppressModalClosingWarning,
  closeModal,
}: Props) => {
  const theme = useTheme();
  return (
    <main>
      <DatabaseContent
        openItemDetail={openItemDetail}
        openResponseForm={openResponseForm}
        form={props.form}
      />
      <Modal
        isOpen={modalContent.__kind !== "HIDE"}
        onRequestClose={closeModal}
        style={{
          overlay: modalOverlayStyle,
          content: modalContentStyle(theme),
        }}
      >
        <div css={closeButtonContainerStyle}>
          <IconButton onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </div>
        {match(modalContent)
          .with({ __kind: ModalContentKind.RESPONSE_FORM }, () => (
            <ResponseModalContent
              form={props.form}
              setModalClosable={setSuppressModalClosingWarning}
              closeModal={closeModal}
            />
          ))
          .with({ __kind: ModalContentKind.ITEM_DETAIL }, ({ response }) => (
            <ItemModalContent form={props.form} response={response} />
          ))
          .with({ __kind: ModalContentKind.HIDE }, () => null)
          .exhaustive()}
      </Modal>
    </main>
  );
};

const modalOverlayStyle = {
  backgroundColor: "rgba(0, 0, 0, 0.5)",
};

const modalContentStyle = (theme: Theme) => ({
  top: "50%",
  left: "50%",
  right: "auto",
  bottom: "auto",
  marginRight: "-50%",
  transform: "translate(-50%, -50%)",
  height: "70dvh",
  border: "4px solid #ccc",
  borderRadius: "1rem",
  padding: "0",
  backgroundColor: theme.palette.background.default,
});

const closeButtonContainerStyle = css`
  ${flexRow};
  justify-content: flex-end;
`;

export default PcPage;
